import React, { useState, useEffect, useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
} from '@mui/material';

export default function TableWizard({ open, onClose, onInsert }) {
  const [rows, setRows] = useState(3);
  const [cols, setCols] = useState(3);
  const [header, setHeader] = useState(true);

  // Reference to the first input for autofocus
  const rowsRef = useRef(null);

  // Focus the first field when the dialog opens
  useEffect(() => {
    if (open && rowsRef.current) {
      rowsRef.current.focus();
    }
  }, [open]);

  // Clamp function
  const clamp = (v, min, max) => Math.max(min, Math.min(max, Number(v) || 0));

  const submit = () => {
    const r = clamp(rows, 1, 20);
    const c = clamp(cols, 1, 12);
    console.debug('[TableWizard] onInsert fired', { rows: r, cols: c, header });
    onInsert({ rows: r, cols: c, hasHeader: !!header });
    // onClose?.(); // optional immediate close
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      // ✅ Ensure MUI manages focus correctly
      disableAutoFocus={false}
      disableEnforceFocus={false}
      disableRestoreFocus={false}
      keepMounted
      container={document.body} // ensure rendered via Portal, not under #root
    >
      <DialogTitle>Insert Table</DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: '1fr 1fr' }}>
          <TextField
            inputRef={rowsRef} // 👈 ensure focus goes here on open
            autoFocus
            type="number"
            label="Rows"
            value={rows}
            onChange={(e) => setRows(e.target.value)}
            inputProps={{ min: 1, max: 20 }}
          />
          <TextField
            type="number"
            label="Columns"
            value={cols}
            onChange={(e) => setCols(e.target.value)}
            inputProps={{ min: 1, max: 12 }}
          />
        </Box>

        <FormControlLabel
          sx={{ mt: 1 }}
          control={<Checkbox checked={header} onChange={(e) => setHeader(e.target.checked)} />}
          label="Header row"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={submit}>
          Insert
        </Button>
      </DialogActions>
    </Dialog>
  );
}
